module.exports = __webpack_public_path__ + "img/img_family_05.d3954a7f.svg";